import ReactGA, { EventArgs } from 'react-ga';

import { GA_ID, TRACKER_ENABLED } from 'env';
import { LoanApplication } from 'generated/graphql';
import { ReactBing } from 'utils/utils';

if (TRACKER_ENABLED) {
    ReactGA.initialize(GA_ID, {
        standardImplementation: true,
        titleCase: false
    });
} else {
    console.log('Inicializando serviços de rastreamento...');
}

const registerPageView = (path: string) => {
    if (TRACKER_ENABLED) {
        ReactGA.pageview(path);
        ReactBing.pageview(path);
    } else {
        console.log(`Registro de pageView [${path}]`);
    }
};

const conversionActions = {
    ga: ({ borrower: { companyDocument } }: LoanApplication) => {
        ReactGA.set({ userId: companyDocument });
        ReactGA.pageview('/pedido/enviou/');
    },
    outbrain: () => {
        const trackKey = 'obApi';

        if (window[trackKey]) {
            window[trackKey]('track', 'LeadBiz');
        }
    },
    twitter: ({ amountRequested }: LoanApplication) => {
        const trackKey = 'twttr';

        try {
            window[trackKey].conversion.trackPid('nxlyz', { tw_sale_amount: amountRequested });
        } catch (e) {
            console.log('twitter conversion');
        }
    },
};

const registerConversion = (loanApplication: LoanApplication) => {
    if (TRACKER_ENABLED) {
        Object.keys(conversionActions).forEach((key: string) => {
            conversionActions[key](loanApplication);
        });

        const dataLayerKey = 'dataLayer';

        if (window[dataLayerKey]) {
            window[dataLayerKey].push({
                event: 'new-lead',
                reason: loanApplication.reason,
                amountRequested: loanApplication.amountRequested,
                cnpj: loanApplication.borrower.companyDocument,
            });
        }
    } else {
        console.log('Registrando conversão...');
    }
};

export const registerEvent = (eventArgs: EventArgs) => {
    if (TRACKER_ENABLED) {
        ReactGA.event(eventArgs);
    }
};

export const registerTagmanagerEvent = (eventName: string, variables?: any) => {
    if (TRACKER_ENABLED) {
        const dataLayerKey = 'dataLayer';

        if (window[dataLayerKey]) {
            window[dataLayerKey].push({
                ...(variables || {}),
                event: eventName,
            });
        }
    }
};

export enum TagManagerEvent {
    ORDER = 'order',
    INTENTION = 'intetion',
    PROFILE = 'profile',
    COMPLETE_PROFILE = 'completeProfile',
    CONFIRMATION_PROFILE = 'confirmationProfile',
    IDENTIFICATION = 'identification',
    DOCUMENTS = 'documentos',
    BORROW = 'borrow',
    PARTNER_LEAD = 'partnerLead',
    PARTNER_SIGNUP = 'partnerSignup',
    PARTNER_CONTACT = 'partnerContact',
    START_SIMULATE = 'startSimulate',
    APPROVED = 'Aprovado',
    DENIED = 'Negado',
}

export {
    registerPageView,
    registerConversion,
};
